import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectWidgetResultByDimensionV2Domain = (state) =>
  state.get("widgetResultByDimensionV2", initialState)

export const makeSelectIsLoadingDimensions = () =>
  createSelector(selectWidgetResultByDimensionV2Domain, (state) =>
    state.get("isLoadingDimensions")
  )

export const makeSelectDimensionsDrillDown = () =>
  createSelector(selectWidgetResultByDimensionV2Domain, (state) =>
    state.get("dimensionsDrillDown")
  )

export const makeSelectDivisions = () =>
  createSelector(selectWidgetResultByDimensionV2Domain, (state) =>
    state.get("divisions")
  )

export const makeSelectShowDimensionBenchmark = () =>
  createSelector(selectWidgetResultByDimensionV2Domain, (state) =>
    state.get("showDimensionBenchmark")
  )

const makeSelectWidgetResultByDimensionV2 = () =>
  createSelector(selectWidgetResultByDimensionV2Domain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetResultByDimensionV2
export { selectWidgetResultByDimensionV2Domain }
